var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c(
      "form",
      {
        attrs: { autocomplete: "off", method: "post", "data-vv-scope": "form" },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return (() => {
              return false
            }).apply(null, arguments)
          },
          submit: function ($event) {
            $event.preventDefault()
            return (() => {
              return false
            }).apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-lg-3 col-xl-2" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      type: "text",
                      id: "input-code",
                      name: "code",
                      inputClasses: [{ "is-invalid": _vm.fnHasError("code") }],
                      error: _vm.fnFirstError("code"),
                    },
                    model: {
                      value: _vm.form.code,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "code",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.code",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.code`)) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-md" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      type: "text",
                      id: "input-name",
                      name: "name",
                      inputClasses: [{ "is-invalid": _vm.fnHasError("name") }],
                      error: _vm.fnFirstError("name"),
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.name",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.name`)) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-auto" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialCheckbox",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      "false-value": "0",
                      "true-value": "1",
                      id: "input-maintenance",
                      name: "maintenance",
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("maintenance") },
                      ],
                      error: _vm.fnFirstError("maintenance"),
                    },
                    model: {
                      value: _vm.form.maintenance,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "maintenance",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.maintenance",
                    },
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.maintenance`))
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-auto" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialCheckbox",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-status",
                      name: "status",
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("status") },
                      ],
                      error: _vm.fnFirstError("status"),
                    },
                    model: {
                      value: _vm.form.status,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "status",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.status",
                    },
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        " " + _vm._s(_vm.$t(`${_vm.modelTranslateID}.status`))
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-sm-12" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-md-6 col-lg-8 col-xl-9" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "city-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.description`))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "city-form-group",
                      class: { "is-invalid": _vm.fnHasError("description") },
                    },
                    [
                      _c("ckeditor", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        attrs: {
                          readonly: _vm.readonlyForm,
                          disabled: _vm.readonlyForm,
                          name: "description",
                          editor: _vm.cKEditor.editor,
                          config: _vm.cKEditor.editorConfig,
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                      _vm._v(" "),
                      _vm.fnFirstError("description")
                        ? _c(
                            "small",
                            { staticClass: "d-block invalid-feedback" },
                            [_vm._v(_vm._s(_vm.fnFirstError("description")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-6 col-lg-4 col-xl-3 city-form-group upload-image",
                },
                [
                  _c("UploadMultipleImage", {
                    attrs: {
                      disabled: _vm.readonlyForm,
                      maxImage: _vm.maxImages,
                      enableMainImage: _vm.enableMainImage,
                      imageSize: _vm.imageSize,
                      imagesPerRow: _vm.imagesPerRow,
                      direction: _vm.imageDirection,
                      noSpaceBetween: true,
                      heightAuto: false,
                      pathProperty: "url",
                      filenameProperty: "filename",
                      extraNewProperties: _vm.newImageProperties,
                      imageClass: "background-contain",
                    },
                    model: {
                      value: _vm.form.images,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "images", $$v)
                      },
                      expression: "form.images",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-lg-3" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-admin1_code",
                      name: "admin1_code",
                      initialData: _vm.form.admin1,
                      label: "name",
                      options: _vm.admin1_codes,
                      reduce: (option) => option.code,
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("admin1_code") },
                      ],
                      error: _vm.fnFirstError("admin1_code"),
                    },
                    on: { selected: _vm.onSelectedAdmin1_code },
                    model: {
                      value: _vm.form.admin1_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "admin1_code", $$v)
                      },
                      expression: "form.admin1_code",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.admin1_code`)) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-lg-3" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-admin2_code",
                      name: "admin2_code",
                      label: "name",
                      initialData: _vm.form.admin2,
                      options: _vm.admin2_codes,
                      reduce: (option) => option.code,
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("admin2_code") },
                      ],
                      error: _vm.fnFirstError("admin2_code"),
                    },
                    on: { selected: _vm.onSelectedAdmin2_code },
                    model: {
                      value: _vm.form.admin2_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "admin2_code", $$v)
                      },
                      expression: "form.admin2_code",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.admin2_code`)) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-lg-6" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-admin3_code",
                      name: "admin3_code",
                      label: "name",
                      initialData: _vm.form.admin3,
                      options: _vm.admin3_codes,
                      reduce: (option) => option.code,
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("admin3_code") },
                      ],
                      error: _vm.fnFirstError("admin3_code"),
                    },
                    on: { selected: _vm.onSelectedAdmin3_code },
                    model: {
                      value: _vm.form.admin3_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "admin3_code", $$v)
                      },
                      expression: "form.admin3_code",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.admin3_code`)) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-lg-3" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialTextarea",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      rows: 5,
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-working_hours",
                      name: "working_hours",
                      inputClasses: [
                        "h-100",
                        { "is-invalid": _vm.fnHasError("working_hours") },
                      ],
                      error: _vm.fnFirstError("working_hours"),
                    },
                    model: {
                      value: _vm.form.working_hours,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "working_hours",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.working_hours",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t(`${_vm.modelTranslateID}.working_hours`)
                        ) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-lg-9 row p-0 m-0" }, [
            _c("div", { staticClass: "col-md-6 col-lg-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyForm,
                        disabled: _vm.readonlyForm,
                        type: "text",
                        id: "input-phone",
                        name: "phone",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("phone") },
                        ],
                        error: _vm.fnFirstError("phone"),
                      },
                      model: {
                        value: _vm.form.phone,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "phone",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.phone",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.phone`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 col-lg-5" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyForm,
                        disabled: _vm.readonlyForm,
                        type: "text",
                        id: "input-email",
                        name: "email",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("email") },
                        ],
                        error: _vm.fnFirstError("email"),
                      },
                      model: {
                        value: _vm.form.email,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "email",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.email",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.email`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 col-lg-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyForm,
                        disabled: _vm.readonlyForm,
                        type: "text",
                        id: "input-web_site",
                        name: "web_site",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("web_site") },
                        ],
                        error: _vm.fnFirstError("web_site"),
                      },
                      model: {
                        value: _vm.form.web_site,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "web_site",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.web_site",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.web_site`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 col-lg-6 col-xl-8" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyForm,
                        disabled: _vm.readonlyForm,
                        id: "input-street",
                        name: "street",
                        label: "name",
                        initialData: _vm.form.street,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("street") },
                        ],
                        error: _vm.fnFirstError("street"),
                      },
                      model: {
                        value: _vm.form.street_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "street_id", $$v)
                        },
                        expression: "form.street_id",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.street`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 col-lg-3 col-xl-2" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: true,
                        disabled: true,
                        type: "number",
                        id: "input-area",
                        name: "area",
                        step: 2,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("area") },
                        ],
                        error: _vm.fnFirstError("area"),
                      },
                      model: {
                        value: _vm.form.area,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "area",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.area",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.area`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 col-lg-3 col-xl-2" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: true,
                        disabled: true,
                        type: "number",
                        id: "input-perimeter",
                        name: "perimeter",
                        step: 2,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("perimeter") },
                        ],
                        error: _vm.fnFirstError("perimeter"),
                      },
                      model: {
                        value: _vm.form.perimeter,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "perimeter",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.perimeter",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.perimeter`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialTextarea",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      rows: 4,
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      type: "text",
                      id: "input-obs",
                      name: "obs",
                      inputClasses: [{ "is-invalid": _vm.fnHasError("obs") }],
                      error: _vm.fnFirstError("obs"),
                    },
                    model: {
                      value: _vm.form.obs,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "obs",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.obs",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.obs`)) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-12" },
            [
              _c("CemeteryFiles", {
                attrs: {
                  panelCfg: _vm.panelCfg,
                  vScope: _vm.vScope,
                  readonlyForm: _vm.readonlyForm,
                  baseTranslateID: _vm.baseTranslateID,
                },
                model: {
                  value: _vm.form.files,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "files", $$v)
                  },
                  expression: "form.files",
                },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }